import axios, { AxiosProgressEvent, AxiosResponse } from "axios";
import { getLocalStorage, getSessionStorage } from "../sessionAndLocalStorage";
import { Image } from "../domain/Image";
import { Envelope } from "./types";
import { createTagQueryString } from "../pages/ImageUploads/helpers";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.interceptors.request.use(
  (config) => {
    const appraisalSessionId = getSessionStorage("appraisalSessionId");
    if (!config.headers.Authorization) {
      const abycAuthToken = getLocalStorage(
        `_abyc_authToken_${appraisalSessionId}`
      );

      if (abycAuthToken) {
        config.headers.Authorization = `Bearer ${abycAuthToken}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export const postImageAsync = async (
  appraisalSessionId: string,
  image: Image,
  onUploadProgressHandler: (event: AxiosProgressEvent) => void
): Promise<Envelope<string>> => {
  const formData = new FormData();
  formData.append("Image", image.imageContent);

  const tagQueryString = createTagQueryString(image);

  const response: AxiosResponse<Envelope<string>, FormData> = await axios({
    method: "POST",
    url: `/v2/Appraisal/${appraisalSessionId}/Image?${tagQueryString}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress: onUploadProgressHandler
  });

  return response.data;
};
